import customerConfig from './customers.json';

const SELECTABLE_CUSTOMER_IDS = new Set(customerConfig.selectableCustomerIds);
const PRODUCTION_CUSTOMERS = customerConfig.productionCustomers;

const sortCustomersByName = (a, b) => a.name.localeCompare(b.name, 'nb');

const SORTED_PRODUCTION_CUSTOMERS = [...PRODUCTION_CUSTOMERS].sort(sortCustomersByName);

const DEV_CUSTOMER = {
  id: 'dev',
  name: 'Utvikling (lokal)',
  slug: 'dev',
  appUrl: 'http://localhost:3001'
};

export const customers =
  process.env.NODE_ENV === 'development'
    ? [
        ...SORTED_PRODUCTION_CUSTOMERS.map((customer) => ({
          ...customer,
          appUrl: 'http://localhost:3001'
        })),
        DEV_CUSTOMER
      ]
    : SORTED_PRODUCTION_CUSTOMERS;

export function isCustomerSelectable(customer) {
  if (!customer) return false;
  if (customer.id === 'dev') {
    return process.env.NODE_ENV === 'development';
  }
  return SELECTABLE_CUSTOMER_IDS.has(customer.id);
}

export function customerAllowsDemoFallback(customer) {
  return Boolean(customer?.allowDemoFallback);
}

export function getCustomerUnlocProjectId(customer) {
  return customer?.unlocProjectId || null;
}

export function getCustomerMapCenter(customer) {
  const lat = customer?.mapCenter?.lat;
  const lng = customer?.mapCenter?.lng;
  if (typeof lat === 'number' && typeof lng === 'number') {
    return { lat, lng };
  }
  return { lat: 59.9139, lng: 10.7522 };
}

/** Hours after oc_last_logon before a phone is treated as logged out. */
export function getCustomerLoginTimeoutHours(customer) {
  const hours = customer?.loginTimeoutHours;
  if (typeof hours === 'number' && hours > 0) {
    return hours;
  }
  return null;
}

export function getCustomerById(id) {
  if (!id) return null;
  return customers.find((customer) => customer.id === id) || null;
}

export function getCustomerByHostname(hostname) {
  if (!hostname) return null;

  const normalized = hostname.toLowerCase();

  return (
    PRODUCTION_CUSTOMERS.find((customer) => {
      if (getHostnameFromAppUrl(customer.appUrl).toLowerCase() === normalized) {
        return true;
      }

      return (customer.hostnames || []).some(
        (hostname) => hostname.toLowerCase() === normalized
      );
    }) || null
  );
}

export function getHostnameFromAppUrl(appUrl) {
  try {
    return new URL(appUrl).hostname;
  } catch {
    return '';
  }
}

/** Production web address shown in commune picker (e.g. bergen.opencare.no). */
export function getCustomerWebHostname(customer) {
  if (!customer) return '';

  if (customer.id === 'dev') {
    return 'localhost:3001';
  }

  if (customer.slug) {
    return `${customer.slug}.opencare.no`;
  }

  return getHostnameFromAppUrl(customer.appUrl);
}
